import media from '@/styles/media';
import theme from '@/styles/theme';
import styled from 'styled-components';

export const AuthTitle = styled.h1`
  font-size: 27px;
  color: ${theme.color.black};
  font-family: ${theme.fontFamily.bold};
  text-align: center;
  margin-top: 80px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.md`
    margin-top: 55px;
    margin-bottom: 20px;
    font-size: 22px;
  `}
`;
